module.exports = __webpack_public_path__ + "img/Avatar-79.0d1a2a7a.svg";